import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { DbNode } from '../types/node';
import { DbUser } from '../types/user';
import { NodeService } from '../http/node-service';
import UserService from '../http/user-service';

export default class AdminUserStore {
    private _nodeId: number;
    private _loading = false;
    private _nodes: DbNode[] = [];
    private _users: DbUser[] = [];

    constructor(nodeId: number = 0) {
        this._nodeId = nodeId;
        makeObservable<AdminUserStore, '_loading' | '_nodes' | '_users'>(this, {
            _loading: observable,
            _nodes: observable,
            _users: observable,
            loading: computed,
            nodes: computed,
            users: computed,
            load: action,
            loadNodes: action,
            loadUsers: action,
        });
    }

    get loading(): boolean {
        return this._loading;
    }

    get nodes(): DbNode[] {
        return this._nodes;
    }

    get users(): DbUser[] {
        return this._users;
    }

    async load() {
        await Promise.all([this.loadNodes(), this.loadUsers()]);
    }

    async loadNode() {
        await this.loadNodes();
    }

    async loadNodes() {
        runInAction(() => {
            this._loading = true;
        });
        try {
            const answer = await NodeService.getNodes(this._nodeId);
            runInAction(() => {
                this._nodes = answer.data;
            });
        } catch (e) {
            throw e;
        } finally {
            runInAction(() => {
                this._loading = false;
            });
        }
    }

    async loadUsers() {
        runInAction(() => {
            this._loading = true;
        });
        try {
            const answer = await UserService.getByNode(this._nodeId);
            runInAction(() => {
                this._users = answer.data;
            });
        } catch (e) {
            throw e;
        } finally {
            runInAction(() => {
                this._loading = false;
            });
        }
    }
}
